import { mdiChevronDown, mdiChevronUp } from '@mdi/js';
import type { MaterialUnit } from 'api/models/mainservice';
import { Collapse, Icon, LabeledText } from 'components';
import MaterialAmountPicker from 'components/forms/hook-form/customForms/Material/MaterialAmountPicker';
import { translateUnitWithValue } from 'helpers/materialHelpers';
import { valueCurrencyUnitShortcut } from 'helpers/priceHelpers';
import { useCustomTranslation } from 'helpers/translationHelper';
import React, { useState } from 'react';

interface Props {
  name: string;
  categoryName: string;
  supplierName: string;
  supplierCode?: string | null;
  description?: string | null;
  identificationNumber?: string | null;
  storedAmount?: number | null;
  hideStored?: boolean;
  price: number;
  amount: number;
  currencyId: string;
  unit: MaterialUnit;
  maxAmount: number;
  extraButton: React.ReactNode;
  onAmountChange: (value: number) => void;
  isAllSelected: boolean;
}

const MaterialListItem: React.FC<Props> = (props): React.ReactElement => {
  const {
    amount,
    extraButton,
    name,
    price,
    currencyId,
    unit,
    maxAmount,
    onAmountChange,
    categoryName,
    description,
    identificationNumber,
    storedAmount,
    supplierCode,
    supplierName,
    isAllSelected,
    hideStored
  } = props;

  const { t } = useCustomTranslation();

  const [showInfo, setShowInfo] = useState(false);

  return (
    <div className="MaterialListItem">
      <div className="MaterialListItem_head">
        <div className="MaterialListItem_head-left">
          <Icon
            onClick={() => (showInfo ? setShowInfo(false) : setShowInfo(true))}
            path={showInfo ? mdiChevronUp : mdiChevronDown}
          />
          <div className="MaterialListItem_head-name">{name}</div>
        </div>
        <div className="MaterialListItem_head-right">
          {!hideStored && (
            <div className="MaterialListItem_head-price">
              {storedAmount !== undefined
                ? translateUnitWithValue(t, unit, storedAmount || 0)
                : t('misc.unlimited')}
            </div>
          )}
          {(amount === 0 || isAllSelected) && extraButton}
          {!isAllSelected && (
            <MaterialAmountPicker
              onChange={onAmountChange}
              maxAmount={maxAmount}
              minAmount={0}
              value={amount}
            />
          )}
        </div>
      </div>
      <Collapse isOpen={showInfo}>
        <div className="MaterialInfoContainer">
          <LabeledText label={t('material.forms.categoryIdLabel')} value={categoryName} />
          <LabeledText
            label={t('material.forms.identificationNumberLabel')}
            value={identificationNumber}
          />
          <LabeledText label={t('material.forms.supplierLabel')} value={supplierName} />
          <LabeledText label={t('material.forms.supplierCodeLabel')} value={supplierCode} />
          <LabeledText
            value={valueCurrencyUnitShortcut(price, currencyId, unit, t)}
            label={t('material.forms.priceLabel')}
          />
        </div>
        <LabeledText label={t('material.forms.descriptionLabel')} value={description} />
      </Collapse>
    </div>
  );
};

export default MaterialListItem;
